import React, { useMemo, memo } from 'react';
import Button from "@material-ui/core/Button";
import { makeStyles } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField";
import { useForm, Controller } from "react-hook-form";
import { useRecoilState } from 'recoil';

import RmDialog from '../../../../Common/UI/Dialog/RmDialog';
import { useSpinner } from '../../../../../core/contexts/SpinnerContext';
import { linkSensor } from "../../../../Common/Apis/VehicleApi";
import { useNotification } from "../../../../../core/contexts/NotificationContext";
import { assetListRefreshState } from '../store/AssetsStore';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },

}));

const SensorAddDialog = ({
  VehicleId,
  onClose,
}) => {

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      txtSerialNumber: '',
    }
  });

  const [refreshStatus, setRefreshStatus] = useRecoilState(assetListRefreshState);

  const { showSuccess } = useNotification();
  const { setSpinner } = useSpinner();

  const muiClasses = useStyles();


  const onSubmit = async (data) => {

    try {

      setSpinner(true);

      await linkSensor(VehicleId, data.txtSerialNumber);

      setRefreshStatus(!refreshStatus);
      showSuccess("success", "sucessfully saved", "", 3000, null);
      onClose();
    }
    catch (err) {
      console.log('err', err);
    }

    setSpinner(false);

  };

  const footerAction = useMemo(() => (
    <>
      <div className={muiClasses.wrapper}>
        <Button
          className="mb-3"
          style={{ fontWeight: "600" }}
          variant="contained"
          onClick={handleSubmit(onSubmit)}
          color="primary"
        >
          Save
        </Button>
      </div>
    </>
  ), []);


  return (
    <RmDialog
      title="Link Sensor"
      onClose={onClose}
      footerActions={footerAction}
    >
      <form onSubmit={handleSubmit(onSubmit)}>

        <div className="modal-content model-dialog">
          <div className="modal-body  pt-0 pb-0">
            <div className="row mt-3 mb-5">
              <div className="col-12">
                <div className="p-number">
                  <Controller
                    name="txtSerialNumber"
                    rules={{ required: true }}
                    control={control}
                    render={({ field }) =>
                      <TextField
                        {...field}
                        style={{ width: "100%" }}
                        label=""
                        variant="outlined"
                        size="small"
                        error={errors.txtSerialNumber ? true : false}
                        helperText={""}
                      />}
                  />
                  <span className="p-num-span mr-2">
                    Sensor Serial Number
                  </span>
                  {errors.txtSerialNumber &&
                    <p className="text-danger2">should not be blank</p>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </RmDialog >);
};

export default memo(SensorAddDialog);